import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		errorPageWrapper: {
			height         : "calc( 100vh - 70px )",
			display        : "flex",
			justifyContent : "center",
			alignItems     : "center"
		},
		reelsRoot: {
			overflow           : "scroll",
			borderRadius       : "1rem",
			maxHeight          : "calc( 100vh - 70px )",
			overscrollBehavior : "none",
			marginBottom       : "0",
			scrollSnapType     : "y mandatory",

			[rooterMediaQuery.mobile]: {
				borderRadius : "0rem !important",
				margin       : "0",
				maxHeight    : "100dvh"
			}
		},
		buttonContainer: {
			position      : "absolute",
			top           : "50%",
			right         : "5%",
			display       : "flex",
			flexDirection : "column",
			gap           : "1rem"
		},
		reelContainer: {
			display                   : "flex",
			flexDirection             : "column",
			gap                       : "3rem",
			width                     : "fit-content",
			margin                    : "3rem auto",
			[rooterMediaQuery.mobile] : {
				margin     : "0",
				background : "black",
				gap        : "0",
				width      : "100vw"
			},
			position: "relative"
		},
		reelsIcon: {
			height : "4rem",
			cursor : "pointer"
		},
		reelsScrollButton: {
			all               : "unset",
			height            : "4rem",
			cursor            : "pointer",
			"&[data-showBtn]" : {
				visibility : "hidden",
				scale      : "0"
			},
			scale        : "1",
			visibility   : "visible",
			borderRadius : "50%",
			transition   : "scale 0.1s ease-in-out, visibility 0.05s ease-in-out"
		},
		reportDialogTitleTypography: {
			flexGrow     : "0",
			fontSize     : "14px",
			fontWeight   : "500",
			fontStretch  : "normal",
			fontStyle    : "500",
			lineHeight   : "1.5",
			textAlign    : "center",
			color        : "white",
			marginBottom : "8px"
		},
		reportDialogTypography: {
			flexGrow     : "0",
			fontSize     : "12px",
			fontWeight   : "500",
			fontStretch  : "normal",
			fontStyle    : "normal",
			lineHeight   : "1.5",
			textAlign    : "center",
			color        : "#757575",
			marginBottom : "8px"
		}

	};
} );